/**
 * Chip Component - Component Definition
 * =======================================
 */

import angular, { IModule, IComponentOptions } from 'angular';

import { ChipController } from './controller';
import { CHIP_TEMPLATE } from './template';
import {
  INTENT_EMPHASIS,
  SIZES,
  BASE_CLASSES,
  ICONS,
  DISMISS_ICON,
  DEFAULTS,
  ChipIntent,
  ChipEmphasis,
  ChipSize,
  ChipIconType
} from './constants';

export interface IChipComponentBindings {
  text?: string;
  intent?: ChipIntent;
  emphasis?: ChipEmphasis;
  size?: ChipSize;
  dismissible?: boolean;
  showIcon?: boolean;
  icon?: ChipIconType;
  onDismiss?: (args: { $event: Event }) => void;
}

export const chipComponentDefinition: IComponentOptions = {
  template: CHIP_TEMPLATE,
  controller: ChipController,
  transclude: true,
  bindings: {
    text: '@',
    intent: '@',
    emphasis: '@',
    size: '@',
    dismissible: '<',
    showIcon: '<',
    icon: '@',
    onDismiss: '&?'
  }
};

export const MODULE_NAME = 'ec.chip';

const chipModule: IModule = angular
  .module(MODULE_NAME, ['ngSanitize'])
  .component('ecChip', chipComponentDefinition);

export { ChipController, CHIP_TEMPLATE, INTENT_EMPHASIS, SIZES, BASE_CLASSES, ICONS, DISMISS_ICON, DEFAULTS };

export type { ChipIntent, ChipEmphasis, ChipSize, ChipIconType } from './constants';

export default chipModule;
